import * as React from 'react'
import Link from 'next/link'

import { Message } from '~/components'
import { useModalManager } from '~/hooks'
import NewButton from '~/truck/new-button/NewButton'
import { images } from '~/utils/constants'

import { ModalContainer } from './elements'
import Header from './header'

const OrdersToBeApprovedAlert = props => {
  const { initialOrderStatusId, modalId } = props

  const { closeModal } = useModalManager()

  return (
    <ModalContainer>
      {/*FIXME: Use flex in modal container*/}
      <Header onClose={() => closeModal(modalId)} />
      <Message
        title="Tienes cambios por aprobar"
        content="Algunos de los pedidos registrados en la tienda han tenido cambios y esperan de tu aprobación para continuar siendo atendidos."
        imageSrc={images.ILLUSTRATION_PAPER_PROBLEM}
      />
      <NewButton onClick={() => closeModal(modalId)} className="mx-auto mt-8 w-fit px-6 py-3">
        <Link href={`/mi-cuenta/pedidos?status=${initialOrderStatusId}`}>Ver pedidos</Link>
      </NewButton>
    </ModalContainer>
  )
}

export default OrdersToBeApprovedAlert
